export default __webpack_public_path__ + "static/gpass_background-1381c4c11ca1cd432300d15c5586d2a9.png";